import { render, staticRenderFns } from "./report-doctors.vue?vue&type=template&id=04b3f29a&"
import script from "./report-doctors.vue?vue&type=script&lang=js&"
export * from "./report-doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports